import React, { Fragment, useState, useEffect } from 'react';
import { useFormik } from 'formik';

import { MenuItem, Select } from '@mui/material';

import { Gridfield, Textfield } from 'components/Form';
import ModalForm from 'components/Modal/Modal';

import { UserBalanceShema, useUser } from 'features/userPage';

const currency = {
  USD: 'USD',
  EUR: 'EUR',
  RMB: 'RMB',
};

const initialValues = {
  id: ``,
  message: ``,
  sum: ``,
  exchangeRate: ``,
  exchangeCurrency: 'USD',
};

const selectStyles = {
  width: '100%',
  '& .MuiSelect-select': {
    padding: '8px 16px',
    fontSize: '13px',
  },
};

const ModalDataComponent = ({ title, isOpen, onClose, userId }) => {
  const [initFormik, setInitFormik] = useState(initialValues);
  const [currencyData, setCurrencyData] = useState(currency.USD);
  const { addDispatchUserBalance, setFetchingUserInfo } = useUser();

  useEffect(() => {
    setInitFormik(initialValues);
  }, []);

  const addBalanceFetcher = (payload) => {
    addDispatchUserBalance(payload)
      .unwrap()
      .then(() => setFetchingUserInfo(true))
      .catch((error) => console.log(error));
  };

  const { values, handleChange, handleSubmit, touched, errors, resetForm } =
    useFormik({
      initialValues: initFormik,
      validationSchema: UserBalanceShema,
      enableReinitialize: true,
      onSubmit: (values) => {
        values.id = userId;
        addBalanceFetcher(values);
        closeModal();
      },
    });

  const handleCurrencyChange = (event) => {
    const value = event.target.value;
    setCurrencyData(value);
    values.exchangeCurrency = value;
  };

  function closeModal() {
    setCurrencyData(currency.USD);
    onClose();
    resetForm();
  }

  const renderModalFields = (
    <Fragment>
      <Gridfield label="Credits">
        <Textfield
          name="sum"
          placeholder="credits"
          value={values.sum}
          onChange={handleChange}
          error={Boolean(errors.sum && touched.sum)}
          helperText={touched.sum && errors.sum}
        />
      </Gridfield>
      <Gridfield label="Notes">
        <Textfield
          name="message"
          placeholder="notes"
          value={values.message}
          onChange={handleChange}
          error={Boolean(errors.message && touched.message)}
          helperText={touched.message && errors.message}
        />
      </Gridfield>
      <Gridfield label="Rate">
        <Textfield
          name="exchangeRate"
          placeholder="rate"
          value={values.exchangeRate}
          onChange={handleChange}
          error={Boolean(errors.exchangeRate && touched.exchangeRate)}
          helperText={touched.exchangeRate && errors.exchangeRate}
        />
      </Gridfield>

      <Gridfield label="Rate">
        <Select
          value={currencyData}
          onChange={handleCurrencyChange}
          sx={selectStyles}
        >
          <MenuItem value={currency.USD}>USD</MenuItem>
          <MenuItem value={currency.EUR}>EUR</MenuItem>
          <MenuItem value={currency.RMB}>RMB</MenuItem>
        </Select>
      </Gridfield>
    </Fragment>
  );

  return (
    <ModalForm
      title={title}
      isOpen={isOpen}
      onClose={closeModal}
      onSubmit={handleSubmit}
    >
      {renderModalFields}
    </ModalForm>
  );
};

const ModalData = React.memo(ModalDataComponent);
export default ModalData;
